import { useScreen } from '../../../../../../../hooks'
import { PhoneSelectFormikField } from '../../../../../../Phone'

function PhoneInput({ card: { label, name, required }, fieldClassName }) {
  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <PhoneSelectFormikField
      controlProps={{
        borderless: !isMobileScreenSize,
      }}
      fieldComponentProps={{
        className: fieldClassName,
        label,
        required,
        shouldAdaptToMobileScreen: true,
      }}
      name={name}
    />
  )
}

export default PhoneInput
